// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3B5Af","rootCenter":"LoadMoreObserver_rootCenter__1CpoD","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__Iq_MC"};